export default {
  setErrors: (state, error) => {
    state.errors = { ...state.errors, ...error };
  },
  setReferenceNumber: (state, response) => {
    state.referenceNumber = response;
  }
};
